import { Button, Card, Checkbox, Input, Typography } from "@material-tailwind/react";
import axios from "axios";
import { type } from "os";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LoginUser, RegisterUser } from "../../services/ApiServices/AuthenticationService";
import "../../styles/login.css";
import LoadingSpinner from "../LoadingSpinner";
import parseJwt from "../../services/parseJwt";
import { CheckIcon } from "@heroicons/react/24/solid";
import { AlertBanner } from "../AlertBanner";

type LoginProps = {
    token: string | null;
    setToken: (token: string) => void;
    removeToken: () => void;
    loading: boolean;
    setLoading: (loading: boolean) => void;
};

function Login({ token, setToken, removeToken, loading, setLoading }: LoginProps) {
    let navigate = useNavigate();
    const [loginEmail, setLoginEmail] = useState("");
    const [loginPassword, setLoginPassword] = useState("");
    const [loginError, setLoginError] = useState("");

    const [registerEmail, setRegisterEmail] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");
    const [registerName, setRegisterName] = useState("");
    const [registerPhone, setRegisterPhone] = useState("");
    const [registerAddress, setRegisterAddress] = useState("");
    const [registerError, setRegisterError] = useState("");

    const [openRegisterSuccess, setOpenRegisterSuccess] = useState(false);


    const handleLoginSubmit = async (e: any) => {
        e.preventDefault();
        let user = null;
        setLoading(true);
        try{
            user = await LoginUser({
                "email":loginEmail,
                "password":loginPassword
            });
            setLoginError("");
        }
        catch (error: any) {
          if (error.response && error.response.data && error.response.data.message) {
            // If the error response contains a message, set it as the error message
            setLoginError(error.response.data.message);
          } else {
            // If the error is something else, set a generic error message
            setLoginError('An error occurred. Please try again later.');
          }
          setLoading(false);
          return;
        }
        setLoading(false);
        setToken(user.token);
        if (parseJwt(user.token).role === "Admin") {
          navigate("/dashboard");
      } else {
          navigate("/");
      }
    }

    const handleRegisterSubmit = async (e: any) => {
        e.preventDefault();
        let user = null;
        setLoading(true);
        try{
            user = await RegisterUser({
                "name": registerName,
                "email":registerEmail,
                "password":registerPassword,
                "phoneNumber": registerPhone,
                "address": registerAddress
            });
            setRegisterError("");
            switchToLogin(e);
            setOpenRegisterSuccess(true);
            setTimeout(() => {
                setOpenRegisterSuccess(false);
            }, 3000);
        }
        catch (error: any) {
          if (error.response && error.response.data && error.response.data.message) {
            // If the error response contains a message, set it as the error message
            setRegisterError(error.response.data.message);
          } else {
            // If the error is something else, set a generic error message
            setRegisterError('An error occurred. Please try again later.');
          }
          setLoading(false);
          return;
        }
        setLoading(false);
        //setToken(user.token);
        navigate("/login");
    }

    const switchToLogin = (e : any) => {
        if(e)
            e.preventDefault();
        const loginCard = document.getElementById("login-card");
        const signupCard = document.getElementById("signup-card");
        const loginBackground = document.getElementsByClassName("login-background")[0];
        loginBackground?.classList.remove("background-right");
        loginCard?.classList.remove("invisible");
        signupCard?.classList.add("invisible");
    }

    const switchToSignup = (e : any) => {
        e.preventDefault();
        const signupCard = document.getElementById("signup-card");
        const loginCard = document.getElementById("login-card");
        const loginBackground = document.getElementsByClassName("login-background")[0];
        loginBackground?.classList.add("background-right");
        signupCard?.classList.remove("invisible");
        loginCard?.classList.add("invisible");
    }

    useEffect(() => {
        var main = document.getElementsByTagName("main")[0];
        if (main) {
            main.style.background = "#FB6B08";
        }
        return () => {
            if (main) {
                main.style.background = "";
            }
        }
    }, [])

    return (
    <div className="flex justify-center w-full my-5 overflow-x-hidden">
        <div className="login-background flex absolute justify-center" style={{width: "100%", height: "800px"}}>
        </div>

        <div className="flex" style={{width: "100%", height: "800px"}}>
            <Card id="signup-card" className="w-full md:w-3/6 absolute md:relative p-2 items-center invisible" color="white" shadow={true} placeholder={""}>
              <Typography variant="h4" color="blue-gray" placeholder={""}>
                Sign Up
              </Typography>
              <Typography color="gray" className="mt-1 font-normal" placeholder={""}>
                Nice to meet you! Enter your details to Login.
              </Typography>
              <form onSubmit={(e) => handleRegisterSubmit(e)} className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96">
                <div className="mb-1 flex flex-col gap-6">
                  <Typography variant="h6" color="blue-gray" className="-mb-3" placeholder={""}>
                    Your Name
                  </Typography>
                  <Input
                    crossOrigin={""}
                    onChange={(e) => setRegisterName(e.target.value)}
                    size="md"
                    placeholder="Your Name"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    style={{transition: "visibility 0s"}}
                  />
                  <Typography variant="h6" color="blue-gray" className="-mb-3" placeholder={""}>
                    Your Email
                  </Typography>
                  <Input
                    crossOrigin={""}
                    size="md"
                    onChange={(e) => setRegisterEmail(e.target.value)}
                    placeholder="name@mail.com"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    style={{transition: "visibility 0s"}}
                  />
                  <Typography variant="h6" color="blue-gray" className="-mb-3" placeholder={""}>
                    Your Phone
                  </Typography>
                  <Input
                    crossOrigin={""}
                    size="md"
                    onChange={(e) => setRegisterPhone(e.target.value)}
                    placeholder="Your Phone"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    style={{transition: "visibility 0s"}}
                  />
                  <Typography variant="h6" color="blue-gray" className="-mb-3" placeholder={""}>
                    Your Address
                  </Typography>
                  <Input
                    crossOrigin={""}
                    size="md"
                    onChange={(e) => setRegisterAddress(e.target.value)}
                    placeholder="Your Address"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    style={{transition: "visibility 0s"}}
                  />
                  <Typography variant="h6" color="blue-gray" className="-mb-3" placeholder={""}>
                    Password
                  </Typography>
                  <Input
                    crossOrigin={""}
                    onChange={(e) => setRegisterPassword(e.target.value)}
                    type="password"
                    size="md"
                    placeholder="********"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    style={{transition: "visibility 0s"}}
                  />
                </div>
                <Checkbox
                  crossOrigin={""}
                  label={
                    <Typography
                      placeholder={""}
                      variant="small"
                      color="gray"
                      className="flex items-center font-normal"
                    >
                      I agree the
                      <a
                        href="#"
                        className="font-medium transition-colors hover:text-gray-900"
                      >
                        &nbsp;Terms and Conditions
                      </a>
                    </Typography>
                  }
                  containerProps={{ className: "-ml-2.5" }}
                />
                <div className="text-red-500">{registerError}</div>
                <Button type="submit" className="mt-6" fullWidth placeholder={""} style={{transition: "visibility 0s"}}
                    disabled={loading}>
                  sign up
                </Button>
                <Typography color="gray" className="mt-4 text-center font-normal" placeholder={""}>
                  Already have an account?{" "}
                  <button onClick={(e) => switchToLogin(e)} className="font-medium text-gray-900">
                    Log In
                  </button>
                </Typography>
                {/* <Typography color="gray" className="mt-4 text-center font-normal" placeholder={""}>
                  Forgot your password?{" "} */}
                  <Link to="/forgotpassword" className="text-blue-500 mt-4 block text-center">
                     Forgot Password?
                  </Link>
                {/* </Typography> */}
              </form>
            </Card>
            <Card id="login-card" className="w-full md:w-3/6 absolute md:relative p-2 items-center" color="white" shadow={true} placeholder={""}>
              <Typography variant="h4" color="blue-gray" placeholder={""}>
                Log In
              </Typography>
              <Typography color="gray" className="mt-1 font-normal" placeholder={""}>
                Welcome back! Enter your details to register.
              </Typography>
              <form onSubmit={(e) => handleLoginSubmit(e)} className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96">
                <div className="mb-1 flex flex-col gap-6">
                  <Typography variant="h6" color="blue-gray" className="-mb-3" placeholder={""}>
                    Email
                  </Typography>
                  <Input
                    crossOrigin={""}
                    size="md"
                    onChange={(e) => setLoginEmail(e.target.value)}
                    placeholder="name@mail.com"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    style={{transition: "visibility 0s"}}
                  />
                  <Typography variant="h6" color="blue-gray" className="-mb-3" placeholder={""}>
                    Password
                  </Typography>
                  <Input
                    onChange={(e) => setLoginPassword(e.target.value)}
                    crossOrigin={""}
                    type="password"
                    size="md"
                    placeholder="********"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    style={{transition: "visibility 0s"}}
                  />
                </div>
                <Checkbox
                  crossOrigin={""}
                  label={
                    <Typography
                      placeholder={""}
                      variant="small"
                      color="gray"
                      className="flex items-center font-normal"
                    >
                      I agree the
                      <a
                        href="#"
                        className="font-medium transition-colors hover:text-gray-900"
                      >
                        &nbsp;Terms and Conditions
                      </a>
                    </Typography>
                  }
                  containerProps={{ className: "-ml-2.5" }}
                />
                <div className="text-red-500">{loginError}</div>
                <Button type="submit" className="mt-6" fullWidth placeholder={""} style={{transition: "visibility 0s"}}
                    disabled={loading}>
                  log in
                </Button>
                <Typography color="gray" className="mt-4 text-center font-normal" placeholder={""}>
                  Don't have an account?{" "}
                  <button onClick={(e) => switchToSignup(e)} className="font-medium text-gray-900">
                    Sign Up
                  </button>
                </Typography>
                <Link to="/forgotpassword" className="text-blue-500 mt-4 block text-center">
                     Forgot Password?
                  </Link>
              </form>
            </Card>
        </div>
        <AlertBanner openAlert={openRegisterSuccess} setOpenAlert={setOpenRegisterSuccess}
                color="green" Badge={CheckIcon} 
                message={"Đăng ký thành công vui lòng đăng nhập lại"} />
    </div>
    )    
}

export default Login;
